module.exports = __webpack_public_path__ + "img/arrow_right_3.f2df972c.svg";